// extracted by mini-css-extract-plugin
export default {"main":"ProfileMainContent_main__qptK9"};